import createCachedSelector from 're-reselect'
import {
  FEATURE_INBOX_MAX_CHANNELS,
  FEATURE_INBOX_MAX_MAILBOXES,
} from 'ducks/billing/featureTypes'
import { INBOX } from 'ducks/billing/productTypes'
import { byProductFeatureCacheKey } from './byProductFeatureCacheKey'
import { selectProductFeatures } from './selectProductFeatures'

export const selectLimitForProductFeature = createCachedSelector(
  selectProductFeatures,
  (_state, product) => product,
  (_state, _product, feature) => feature,
  (features, product, feature) => {
    // special case:
    // if feature is mailboxes, use channels BUT if limit for channels is unlimited, use value from mailboxes
    if (product === INBOX && feature === FEATURE_INBOX_MAX_MAILBOXES) {
      const channelsFeatureLimit = features[FEATURE_INBOX_MAX_CHANNELS]
      if (channelsFeatureLimit === 'unlimited') return channelsFeatureLimit
    }
    return features[feature]
  }
)(byProductFeatureCacheKey)
